import { Grid, TextField } from '@mui/material';
import { useState } from 'react';
import {
  useCreateHardwareCategoryMutation,
  useFindAllHardwareCategoriesQuery,
  useFindOneHardwareCategoryQuery,
  useRemoveHardwareCategoryMutation,
  useUpdateHardwareCategoryMutation,
} from '../../api/api-hooks';
import ItemOptionsBar from '../../components/ItemOptionsBar';
import { Item } from '../../utils/sharedTypes';
import { nullStringCheck } from '../../utils/stringManipulation';

interface Props {
  selectedCategories: Item[];
  setSelectedCategories: React.Dispatch<React.SetStateAction<Item[]>>;
}

interface CategoryForm {
  categoryName: string;
}

const addFormInitialState: CategoryForm = {
  categoryName: '',
};

const HardwareCategoriesOptionsBar = ({
  selectedCategories,
  setSelectedCategories,
}: Props) => {
  const [deleteCategory] = useRemoveHardwareCategoryMutation();
  const [createCategory] = useCreateHardwareCategoryMutation();
  const [editCategory] = useUpdateHardwareCategoryMutation();
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const { data: categories } = useFindAllHardwareCategoriesQuery({});
  if (categories === undefined) return null;
  return (
    <>
      <ItemOptionsBar
        selectedItems={selectedCategories}
        setSelectedItems={setSelectedCategories}
        handlerMiddleware={() => ({})}
        dialogSize='sm'
        editModalOpen={editModalOpen}
        setEditModalOpen={setEditModalOpen}
        itemValidator={(item: any) => {
          if (!item.categoryName) return false;
          return true;
        }}
        formInstructions='Category name is required.'
        addFormInitialState={addFormInitialState}
        itemName='Hardware Category'
        childrenCreator={(addFormState: CategoryForm, handler: any) => (
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <TextField
                margin='dense'
                name='categoryName'
                label='Category Name'
                fullWidth
                value={nullStringCheck(addFormState.categoryName)}
                onChange={handler}
              />
            </Grid>
          </Grid>
        )}
        itemCreator={(item: CategoryForm) => {
          if (!item.categoryName) return;
          return createCategory({
            createHardwareCategoryDto: {
              categoryName: item.categoryName,
            },
          });
        }}
        itemGetter={useFindOneHardwareCategoryQuery}
        itemUpdater={(item: CategoryForm) => {
          if (!item.categoryName) return;
          return editCategory({
            id: Number(selectedCategories[0].id),
            updateHardwareCategoryDto: {
              id: Number(selectedCategories[0].id),
              categoryName: item.categoryName,
            },
          });
        }}
        itemDeleter={deleteCategory}
        deleteNotes='Deleting a category will delete associated hardware types, hardware, inventory, and firmware. Please use caution.'
      />
    </>
  );
};

export default HardwareCategoriesOptionsBar;
